module.exports = __webpack_public_path__ + "img/cameraNotFound.a6c7acec.png";